/** Identity tints drawn from tokens that carry no money meaning (never income, expense or ok/danger). */
export const AVATAR_TONES = ['--color-accent', '--color-transfer', '--color-attention'] as const
export type AvatarTone = (typeof AVATAR_TONES)[number]

/** Derived from the contact's id, so the colour is stable across sessions and never stored. */
export function avatarToneFor(id: string): AvatarTone {
  let hash = 0
  for (const character of id) hash = (hash * 31 + character.charCodeAt(0)) >>> 0
  return AVATAR_TONES[hash % AVATAR_TONES.length]!
}
